import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
const StickyWrapper = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: ${({ $top })=>{
    return $top !== null && $top !== void 0 ? $top : '0';
}}px;
  z-index: ${({ $layer })=>{
    return `var(--zindex-layer-0${$layer !== null && $layer !== void 0 ? $layer : '0'})`;
}};
`;
/**
 * @param enableSticky - To enable the sticky effect. true by default
 * @param top - Distance from top
 * @param layer - Z-index layer, check varables.css
 */ export const Sticky = ({ enableSticky = true, top = 0, layer, children })=>{
    return enableSticky ? /*#__PURE__*/ _jsx(StickyWrapper, {
        $top: top,
        $layer: layer,
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};
